/**
 * Left-pads a number with zeros to a minimum length (default 2), e.g. 7 → "07".
 */
export function pad(value: number, length = 2): string {
  return String(value).padStart(length, '0');
}

export function isNumeric(value: any): value is number {
  if (typeof value === 'number' && !Number.isNaN(value)) {
    return true;
  }

  if (typeof value === 'string') {
    const number = Number(value);
    return !Number.isNaN(number) && Number.isFinite(number);
  }

  return false;
}
